import { isInAppSelector } from 'src/selector/app';
import { useSelector } from 'react-redux';
import { useCallback, useEffect } from 'react';
import { appReadySelector } from 'src/selector/app';

export default function useHupspotTopBannerLayout() {
  const isInApp = useSelector(isInAppSelector);
  const appReady = useSelector(appReadySelector);

  const updateHubspotTopBannerOpenHeight = useCallback(() => {
    const hubspotTopBannerOpenTargetNode = document.querySelector('#hs-web-interactives-top-push-anchor');
    if (hubspotTopBannerOpenTargetNode) {
      if (document.body.classList.contains('hs-web-interactives-top-banner-open')) {
        document.body.style.setProperty(
          '--hs-web-interactives-top-banner-open-height',
          `${hubspotTopBannerOpenTargetNode.getBoundingClientRect().height}px`
        );
      } else {
        document.body.style.setProperty('--hs-web-interactives-top-banner-open-height', '0px');
      }
    } else {
      document.body.style.setProperty('--hs-web-interactives-top-banner-open-height', '0px');
    }
  }, []);

  const setupHubspotTopPushAnchorObserver = useCallback(() => {
    updateHubspotTopBannerOpenHeight();
    const hubspotTopPushAnchorObserver = () => {
      const hubspotTopBannerOpenTargetNode = document.querySelector('#hs-web-interactives-top-push-anchor');
      if (!hubspotTopBannerOpenTargetNode) return null;
      let observer = new MutationObserver((mutationList) => {
        updateHubspotTopBannerOpenHeight();
      });
      observer.observe(hubspotTopBannerOpenTargetNode, {
        attributes: true,
      });
      return () => {
        observer && observer.disconnect();
      };
    };

    return hubspotTopPushAnchorObserver;
  }, [updateHubspotTopBannerOpenHeight]);

  useEffect(() => {
    if (isInApp || !appReady) {
      document.body.style.setProperty('--hs-web-interactives-top-banner-open-height', '0px');
      return;
    }

    let hubspotTopPushAnchorObserverDisconnectCall = null;
    // onCallToActionReady	The CTA has finished loading, and has been fully rendered.
    // onCallToActionViewed	The CTA has entered the user's viewport. This event will only fire once.
    // onCallToActionNavigated	A link was clicked within the CTA.
    // onCallToActionFormSubmitted	A form within the CTA was submitted. When triggered, the event payload will include the formId.
    const messageHandler = (event) => {
      let data = event.data || {};
      if (data.type === 'hsCallsToActionCallback') {
        console.log('hsCallsToActionCallback.messageHandler.event.data', event.data);
      }

      if (
        data.type === 'hsCallsToActionCallback' &&
        (data.eventName === 'onCallToActionReady' || data.eventName === 'onCallToActionViewed')
      ) {
        if (!hubspotTopPushAnchorObserverDisconnectCall) {
          hubspotTopPushAnchorObserverDisconnectCall = setupHubspotTopPushAnchorObserver();
        }
      }
    };
    updateHubspotTopBannerOpenHeight();
    window.addEventListener('message', messageHandler);
    return () => {
      window.removeEventListener('message', messageHandler);
      hubspotTopPushAnchorObserverDisconnectCall && hubspotTopPushAnchorObserverDisconnectCall();
    };
  }, [isInApp, appReady, updateHubspotTopBannerOpenHeight]);

  useEffect(() => {
    let hubspotTopPushAnchorObserverDisconnectCall = null;
    if (!isInApp && appReady && window.HubSpotCallsToActions) {
      console.log('window.HubSpotCallsToActions.refresh when appReady');
      window.HubSpotCallsToActions.refresh();
      hubspotTopPushAnchorObserverDisconnectCall = setupHubspotTopPushAnchorObserver();
    }
    return () => {
      hubspotTopPushAnchorObserverDisconnectCall && hubspotTopPushAnchorObserverDisconnectCall();
    };
  }, [appReady, isInApp, updateHubspotTopBannerOpenHeight]);
}
